<el-dialog>
    <dialog #overrideDialog [id]="dialogId()" [attr.aria-labelledby]="dialogId() + '-title'"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 z-20 focus:outline-none" (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block h-full w-2/3 transform p-4 transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full min-h-0 flex-col overflow-hidden rounded-xl shadow-xl">

                    <div class="flex h-full min-h-0 flex-col divide-y divide-border overflow-hidden">

                        <div class="drawer-header-primary shrink-0 px-2 py-4">
                            <div class="flex h-full items-center space-x-3">
                                <div class="min-w-0 flex-1 px-2">
                                    <p class="text-md font-semibold text-primary" [id]="dialogId() + '-title'">
                                        Override decision
                                    </p>
                                    <p class="text-sm text-secondary">
                                        Lower this flag and record why.
                                    </p>
                                </div>

                                <div class="flex h-full flex-col items-end justify-between">
                                    <button type="button" (click)="closeDrawer()"
                                        class="fab-button-secondary text-secondary" aria-label="Close override">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5"
                                            aria-hidden="true">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div
                            class="drawer-body-primary relative flex h-full min-h-0 w-full flex-1 flex-col divide-y divide-border overflow-hidden">
                            <div class="grid h-full min-h-0 w-full grid-cols-2 gap-2">
                                <div class="col-span-1 flex h-full min-h-0 w-full items-center justify-center p-2">
                                    <div
                                        class="flex h-full min-h-0 w-full items-center justify-center overflow-hidden rounded-lg border border-border">
                                        @if (content().mediaKind === 'image') {
                                        <img class="h-auto max-h-full w-auto max-w-full object-contain"
                                            [src]="content().contentUrls[0]" [alt]="content().contentUrl || 'Content'" />
                                        } @else if (content().mediaKind === 'video') {
                                        <video class="h-auto max-h-full w-auto max-w-full object-contain"
                                            [src]="content().contentUrls[0]" controls playsinline
                                            preload="metadata"></video>
                                        } @else if (content().mediaKind === 'carousel') {
                                        <div class="grid h-full min-h-0 w-full auto-rows-fr grid-cols-2 gap-2">
                                            @for (url of content().contentUrls; track url) {
                                            <div class="flex min-h-0 min-w-0 items-center justify-center">
                                                <img class="h-auto max-h-full w-auto max-w-full object-contain"
                                                    [src]="url" [alt]="content().contentUrl || 'Content'" />
                                            </div>
                                            }
                                        </div>
                                        } @else {
                                        <div class="flex h-full w-full items-center justify-center">
                                            <p class="m-0 text-sm text-secondary">No media</p>
                                        </div>
                                        }
                                    </div>
                                </div>
                                <div class="col-span-1 flex h-full min-h-0 w-full flex-col p-2">
                                    <div
                                        class="flex h-full min-h-0 w-full flex-col gap-3 overflow-hidden rounded-lg border border-border p-4">
                                        <label class="text-sm font-semibold text-foreground" [attr.for]="noteId()">
                                            Why are you overriding this decision?
                                        </label>
                                        <textarea [id]="noteId()" rows="8"
                                            class="min-h-0 w-full flex-1 resize-none rounded-lg border border-border bg-card p-3 text-sm text-foreground"
                                            [value]="note()" (input)="onNoteInput($event)"
                                            [disabled]="saveState() === 'saving'"></textarea>
                                        @if (saveState() === 'error') {
                                        <p role="alert" class="m-0 text-sm text-red-600 dark:text-red-400">
                                            The override could not be saved. Try again.
                                        </p>
                                        }
                                        <button type="button"
                                            class="btn-shout btn-shout-sm btn-shout-primary shrink-0 justify-center"
                                            [disabled]="!canCommit()" (click)="commit()">
                                            Commit override
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>
